<template>
  <span
    class="table-sort-container mr-1 height-limit"
    @click="$emit('click')"
  >
    <RsIcon
      :class="`sort-icon--up${descActive ? '--active' : ''}`"
      weight="fa"
      icon="chevron-up"
    />

    <RsIcon
      :class="`sort-icon--down${ascActive ? '--active' : ''}`"
      weight="fa"
      icon="chevron-down"
    />
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsDynamicSortButton',
  props: {
    descActive: {
      type: Boolean,
      default: false,
    },
    ascActive: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['click'],
});
</script>
